import { TableHeaderButton } from 'modules/campaignIndex/components/TableHeaderButton';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { useSortingContext } from 'utils/contexts/sorting';
import { GOALS_HEADER_GRIDS, GOALS_INDEX_COLUMNS } from '../../constants';
import { GoalsTableColumn } from '../../types';

type GoalsTableHeaderProps = { columns?: GoalsTableColumn[] };

export const GoalsTableHeader = ({ columns = GOALS_INDEX_COLUMNS }: GoalsTableHeaderProps) => {
  const { sortBy, sortDirection, setSortBy, setSortDirection } = useSortingContext();

  return (
    <HeaderGridRow gridLayout={GOALS_HEADER_GRIDS}>
      {columns.map((column) => (
        <TableHeaderButton
          key={column.id}
          sortDirection={sortDirection}
          onSortByChange={setSortBy}
          onSortDirectionChange={setSortDirection}
          isActiveSortColumn={column.id === sortBy}
          isSortable={!!column?.isSortable}
          {...column}
        />
      ))}
    </HeaderGridRow>
  );
};
